import React, { Component } from 'react'
import UnitTable from './UnitTable'
import { connect } from 'react-redux'
import { Redirect, withRouter, Link } from 'react-router-dom'
import { getProperty } from '../../helpers/properties'
import { Edit } from '@mui/icons-material';

import Survey from './Survey'
import qs from 'qs'
import { getEnrolmentDeadlines, getStudentProgress } from '../../services/vu'
import { getCalendarTypeName, getEnrolUrl, addVirtualUnits, removeVirtualUnitsOverlappingRealUnits, isEligibleToEnrolNow, hasSanctions } from '../../helpers/enrolment'
import { formatDate } from '../../actions/dateUtility';

import Modal from './Modal'
import AdmissionCategory from '../../enums/AdmissionCategory'
import CommencementStatus from '../../enums/CommencementStatus'
import ProcessType from '../../enums/ProcessType'
import ResidencyType from '../../enums/ResidencyType'
import BlockType from '../../enums/BlockType'
import Loading from './Loading'
import { getConfiguration } from '../../helpers/configuration'
import SanctionCard from './SanctionCard'
import AllSettled from '../../enums/AllSettled'

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse }, units, personalDetails }) => {
  return {
    courseId: selectedCourseCode,
    course: selectedCourse,
    admissionCategory: selectedCourse.admissionCategory,
    isSelfManagedCourse: selectedCourse.isSelfManagedCourse,
    enrolmentYearsAsString: selectedCourse.enrolmentYearsAsString ? selectedCourse.enrolmentYearsAsString : '',
    commencementStatus: selectedCourse.isCommencing,
    hasBlockStatus: selectedCourse.blockCode === BlockType.FourWeekBlock || selectedCourse.blockCode === BlockType.EightWeekBlock,
    blockMode: selectedCourse.blockCode,
    parentSSPNo: selectedCourse.parentSSPNo,
    units: units[selectedCourseCode].items,
    personalDetails: personalDetails.data,
    loadingPersonalDetails: personalDetails.isFetchingPersonalDetails
  }
}

class EnrolmentEdit extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loadSurvey: false,
      openModal: false,
      enrolmentDeadlines: [],
      loadingEnrolmentProgress: true,
      loadingEnrolmentDeadlines: true,
      completedEnrolment: true,
      enrolmentYear: this.props.enrolmentYear
    }
  }

  componentDidMount() {
    this.setEnrolmentDeadlines()
    this.updateEnrolUrl()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.courseId !== this.props.courseId) {
      this.updateEnrolUrl()
      this.setEnrolmentDeadlines()
      this.setState({
        enrolmentYear: this.props.enrolmentYear
      })
    } else if (prevProps.enrolmentYear !== this.props.enrolmentYear) {
      this.setState({       
        enrolmentYear: this.props.enrolmentYear
      })
    }
  }

  // preparePage = () => {
  //   return Promise.allSettled([getStudentProgress(this.props.courseId), getEnrolmentDeadlines(this.props.parentSSPNo)])
  //   .then(([studyProgressRes, enrolmentDeadlinesRes]) => {
  //     let newState = {
  //     }

  //     if (studyProgressRes.status === AllSettled.FULFILLED) {
  //       let progress = studyProgressRes.value

  //       newState = {
  //         ...newState,
  //         loadingEnrolmentProgress: false,
  //         completedEnrolment: progress && progress.currentPage && progress.currentPage.indexOf('thankyou') > -1 
  //       }
  //     }

  //     if (enrolmentDeadlinesRes.status === AllSettled.FULFILLED) {
  //       let enrolmentDeadlines = enrolmentDeadlinesRes.value

  //       newState = {
  //         ...newState,
  //         loadingEnrolmentDeadlines: false,
  //         enrolmentDeadlines: enrolmentDeadlines
  //       }
  //     }

  //     return newState
  //   })
  // }

  updateEnrolUrl = () => {
    this.setState({
      loadingEnrolmentProgress: true
    })

    //set Flag if student has completed enrolment
    getStudentProgress(this.props.courseId).then(progress => {
      this.setState({
        loadingEnrolmentProgress: false,
        completedEnrolment: progress && progress.currentPage && progress.currentPage.indexOf('thankyou') > -1
      })
    })
  }
  

  setEnrolmentDeadlines = () => {
    this.setState({
      loadingEnrolmentDeadlines: true
    })
    getEnrolmentDeadlines(this.props.parentSSPNo).then((enrolmentDeadlines = []) => {
      this.setState({
        loadingEnrolmentDeadlines: false,
        enrolmentDeadlines: enrolmentDeadlines
      })
    })
  }

  getEnrolUrl = () => {
    const { commencementStatus, courseId, enrolmentYearsAsString } = this.props

    const { completedEnrolment } = this.state

    return getEnrolUrl(commencementStatus, courseId, completedEnrolment, enrolmentYearsAsString)
  }

  getUnitsByYear = year => this.props.units.filter(unit => unit.unitAvailabilityYear === parseInt(year))

  getCalendarOpenByYear = year => this.props.enrolmentYearsAsString.includes(year)

  getSortedCalendars = () => {
    const calendarInfo = this.state.enrolmentDeadlines.filter(enrolmentDeadlines => enrolmentDeadlines.year === parseInt(this.state.enrolmentYear))
    return calendarInfo.sort((a, b) => {
      const aEndTime = new Date(a.studyPeriodEndDate)
      const bEndTime = new Date(b.studyPeriodEndDate)

      if (aEndTime < bEndTime) {
        return -1
      }

      if (aEndTime > bEndTime) {
        return 1
      }

      return 0
    })
  }

  getUpcomingDeadline = () => {
    const sortedCalendarTypes = this.getSortedCalendars()
    if (sortedCalendarTypes.length > 0) {
      const expiringCalendarType = sortedCalendarTypes[0]
      return (
        <span>
          <strong>Upcoming deadline</strong>: <i>{expiringCalendarType.studyPeriodDescription}</i> can not be edited after{' '}
          {expiringCalendarType.studyPeriodEndDate === null ? '' : formatDate(expiringCalendarType.studyPeriodEndDate, 'd MMM yyyy')}
        </span>
      )
    }
    return null
  }

  hasDropDate = units => {
    return units.some(unit => this.unitHasDropDate(unit) && new Date(this.unitWithdrawalDate(unit)) < this.unitLocationStartDate(unit))
  }

  unitHasDropDate = unit => {
    return unit && this.unitWithdrawalDate(unit) !== null
  }

  unitLocationStartDate = unit => {
    return unit.locationStartDate ? new Date(unit.locationStartDate) : new Date(unit.availabilityEndDate)
  }

  unitWithdrawalDate = unit => {
    return unit.lastEstudentWdDate !== null ? unit.lastEstudentWdDate : unit.lastWdDate !== null ? unit.lastWdDate : unit.availabilityEndDate
  }

  renderCustomDropDateText = units => {
    if (!this.hasDropDate(units)) {
      return
    }
    return (
      <p>
        <strong>Important:</strong> Your enrolment contains at least one unit which has an early online withdraw deadline (noted below those units). If the deadline has passed, you will
        require college approval to make any amendment to those units. Refer to{' '}
        <a className="txt-link" href="https://www.vu.edu.au/current-students/your-course/enrolment/change-your-enrolment/add-or-drop-units" target="_blank">
          {' '}
          Early Online Withdraw Deadlines
        </a>
        .
      </p>
    )
  }

  handleOpenModal = (e) => {
    e.preventDefault();
    this.setState({
      openModal: true
    })
  }

  handleCloseModal = () => {
    this.setState({
      openModal: false
    })
  }

  isDomesticStudent = () => {
    return ResidencyType.Domestic.includes(this.props.personalDetails.stuCitizenCd)
  }

  isContinuingStudent = () => {
    return !this.props.commencementStatus
  }

  isDomesticContinuingStudent = () => this.isDomesticStudent() && this.isContinuingStudent()

  getUnitsAndVirtualUnits = units => {
    if (this.props.hasBlockStatus) {
      let virtualUnitset = addVirtualUnits(units)
      return removeVirtualUnitsOverlappingRealUnits(virtualUnitset)
    } else {
      return units
    }
  }

  renderSideNote = (year, units, eligibleToEnrolNow) => {
    if (hasSanctions(this.props.personalDetails, this.props.courseId)) {
      return <SanctionCard sanctions={this.props.personalDetails.studentSanctions} courseId={this.props.courseId} />
    } else if (this.getCalendarOpenByYear(year) && eligibleToEnrolNow) {
      return (
        <div className="sidenote sidenote--info">
          <div className="sidenote__content">
            <div className="row">
              <div className="col-xs-12 col-md-8">
                <h3 style={{ paddingTop: 0 }}>You can edit your enrolment</h3>
                {/*<p><a className="txt-link" href="">View Your Deadlines</a></p>*/}
                {this.isDomesticContinuingStudent() && (
                  <p>
                    We have redesigned our online enrolment system.{' '}
                    <a className="txt-link" href="https://www.youtube.com/watch?v=6lc0U4ClLSQ" target="_blank">
                      Watch a video
                    </a>{' '}
                    about how to amend your enrolment using our new system or{' '}
                    <a className="txt-link" href="https://askvu.vu.edu.au/app/answers/detail/a_id/2975" target="_blank">
                      read the how to guide
                    </a>
                    . You can also call VUHQ if you have any issues on <b>+61 3 9919 6100</b>.
                  </p>
                )}
                <p>
                  {this.getUpcomingDeadline()}{' '}
                  <a className="txt-link" href="#" onClick={this.handleOpenModal}>
                    View deadlines
                  </a>
                </p>
                <p>{this.renderCustomDropDateText(units)}</p>
              </div>
              {eligibleToEnrolNow && (
                <div className="col-xs-12 col-md-4">
                  <p>
                    <a className="btn btn-lg btn-secondary" href={this.getEnrolUrl()}>
                      <Edit /> Edit enrolment{' '}
                    </a>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  render() {
    if (this.state.loadingEnrolmentProgress || this.state.loadingEnrolmentDeadlines || this.props.loadingPersonalDetails) {
      return (
        <section className="tile-container">
          <Loading message="Loading your units..." />
        </section>
      )
    }

    const year = this.state.enrolmentYear
    const units = this.getUnitsByYear(year)
    let eligibleToEnrolNow = isEligibleToEnrolNow(this.props.course, hasSanctions(this.props.personalDetails, this.props.courseId))

    if (units.length === 0) {
      return <Redirect to={`${getConfiguration('baseUrl')}/enrolments`} />
    }

    return (
      <div className="page page-enrolments">
        <div className="row">
          <div className="col-xs-12">
            <section className="enrolment-container">
              <UnitTable year={this.state.enrolmentYear} hasBlockStatus={this.props.hasBlockStatus} units={this.getUnitsAndVirtualUnits(units)} blockMode={this.props.blockMode} />
            </section>
          </div>
        </div>

        {this.renderSideNote(year, units, eligibleToEnrolNow)}

        <Modal className="modal-lg" isOpen={this.state.openModal} handleCloseModal={this.handleCloseModal} title="Enrolment deadlines">
          <table className="table">
            <thead>
              <tr>
                <th>Teaching period</th>
                <th>Editable by</th>
              </tr>
            </thead>
            <tbody>
              {this.getSortedCalendars().map(({ studyPeriodDescription, studyPeriodEndDate }) => {
                const calendarEndTime = studyPeriodEndDate? formatDate(studyPeriodEndDate, 'd MMM yyyy') : ''
                return (
                  <tr key={studyPeriodEndDate}>
                    <td>{studyPeriodDescription}</td>
                    <td>{calendarEndTime}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          <div className="sidenote sidenote--fyi">
            <div className="sidenote__content">
              <p>
                <strong>NOTE:</strong> You may{' '}
                <strong>
                  <em>withdraw</em>
                </strong>{' '}
                early from units until <a href='https://www.vu.edu.au/current-students/your-course/fees/higher-education-fees/higher-education-census-payment-deadlines'>census date</a>. Any
                unit withdrawal made after Census date will occur a financial penalty. If withdrawal is made after Census and Withdrawal without Fail date, you will receive financial and
                academic penalty for that unit.
              </p>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(EnrolmentEdit))
